import { PropTypes } from "@l2r-front/l2r-proptypes"

import * as Styled from "./YearSelector.styled"

export function YearSelectorError(props) {

    const { errorText } = props

    return <Styled.ErrorWrapper id="yearselector-error">
        <Styled.ErrorText variant="H4">{errorText}</Styled.ErrorText>
    </Styled.ErrorWrapper>
}

YearSelectorError.propTypes = {
    errorText: PropTypes.string.isRequired,
}